<template>
    <div>
        <!--消费列表-->
        <header class="form-title">
            <Row>
                <Col span="24">
                    <Form  inline  :label-width="80" >
                        <FormItem  label="选择时间" style="margin-right: 200px">
                            <DatePicker
                                    split-panels
                                    type="daterange"
                                    :options="options"
                                    placeholder="选择日期"
                                    @on-change="modifyTime"
                                    :value="valuedate"
                            >
                            </DatePicker>
                        </FormItem>
                        <FormItem  label="收入:" style="margin-right: 30px">
                            <strong class="result">{{summoney}}</strong>
                        </FormItem>
                        <FormItem  label="支出:" style="margin-right: 30px">
                            <strong class="result">{{expend}}</strong>
                        </FormItem>
                        <FormItem  label="结余:" style="margin-right: 30px">
                            <strong class="result">{{(summoney-expend).toFixed(2)}}</strong>
                        </FormItem>
                    </Form>
                </Col>
            </Row>
        </header>
        <Table stripe :columns="columns" :data="data" :loading="loadingTable">
            <template slot-scope="{ row, index }" slot="first">
                 {{row.type}}
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <Button type="primary" size="small" v-if="row.ordertype==1" @click="$router.push({path:'/historyDetail',query:{id:row.id}})">详情</Button>
                <Button type="primary" size="small" v-if="row.ordertype==2" @click="$router.push({path:'/salesListDetail',query:{id:row.id}})">详情</Button>
                <Button type="primary" size="small" v-if="row.ordertype==5" @click="$router.push({path:'/RememberDetail',query:{id:row.id}})">详情</Button>
                <Button type="primary" size="small" v-if="row.ordertype==3" @click="openFn(row)">详情</Button>
            </template>
        </Table>
        <div class="pageTotal"  >
            <Page :total="page.total"
                  show-total
                  :page-size="page.rows"
                  @on-change="onGongPageTotal" />
        </div>
        <!--详情-->
        <Modal
                v-model="detailModal"
                width="500"
                title="详情">
                <Form :label-width="100" >
                    <FormItem label="客户/供应商："   >
                        <strong>{{ thispageData.other}}</strong>
                    </FormItem>
                    <FormItem label="操作人："  >
                        <strong>{{operationName}}</strong>
                    </FormItem>
                    <FormItem label="结算账户">
                        <strong>{{thispageData.type}}</strong>
                    </FormItem>
                    <FormItem label="结算类型：">
                        <strong>{{thispageData.tradetypename}}</strong>
                    </FormItem>
                    <FormItem label="本次收款：">
                        <strong>{{0-thispageData.bankmoney}}</strong>
                    </FormItem>
                    <FormItem label="业务时间：">
                        <strong>{{thispageData.time}}</strong>
                    </FormItem>
                    <FormItem label="备注" >
                        <strong>{{remark}}</strong>
                    </FormItem>
                     
            </Form>
            <div slot="footer">
                <Button  @click="detailModal=false">取消</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                pagType:'',
                detailModal:false,
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },
                columns: [
                    {title: '店铺', key: 'shopName',align:'center'  },
                    {title: '支付方式', key: 'type',align:'center'},
                    {title: '收入类型', key: 'tradetypename',align:'center'},
                    {title: '交易方', key: 'other',align:'center'},
                    {title: '实收金额', key: 'bankmoney',align:'center'},
                    {title: '单据', key: 'ordercode' ,align:'center' },
                    {title: '时间', key: 'time' ,align:'center' },
                    {title: '操作', key: 'edit' ,align:'center',slot: 'action',},
                ],
                data: [],
                summoney:0,//收入
                expend:0,//支出
                dataTotl:{},
                page:{
                    total:0,
                    page:1,
                    rows:12
                },
                loadingTable:true,
                getData:[],
                thispageData:{},
                operationName:JSON.parse(localStorage.getItem('adminUser')).name,
                remark:''
        
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.valuedate[0] = this.fun_date(0)
            this.valuedate[1] = this.nowTime
            this.pagType=this.$route.query.id //支付类型
            this.selectTrade(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows,this.pagType)
        },

        methods: {
            //获取列表
            selectTrade(startTime,endTime,page,rows,id){
                this.$Api.selectTrade({
                    cid: this.cid,
                    sid: this.sid,
                    page: page,
                    rows: rows,
                    ordertype:'',
                    banktype:id,
                    beantime: startTime,
                    endtime:endTime,
                }).then(res => {
                    if(res.code==200){
                        this.data=[]
                        this.page.total = res.count
                        this.summoney = res.summoney
                        this.expend =res.expend
                         this.getData = res.data
                        res.data.forEach((item,index)=>{
                             var PurchaseList={}
                            if(id==1){
                                PurchaseList.type="柜台现金"
                            }
                            if(id==4){
                                PurchaseList.type="微信"
                            }
                            if(id==3){
                                PurchaseList.type="支付宝"
                            }
                            if(id==2){
                                PurchaseList.type="银行卡"
                            }
                            if(id==6){
                                PurchaseList.type="会员卡"
                            }
                            if(id==5){
                                PurchaseList.type="其他"
                            }
                             PurchaseList.bankmoney =  item.bankmoney,
                             PurchaseList.id = item.orderid,
                              PurchaseList.ids =item.id
                             PurchaseList.shopName =item.shopName,
                             PurchaseList.ordertype= item.ordertype,
                             PurchaseList.tradetypename= item.tradetypename,
                             PurchaseList.other=item.other,
                             PurchaseList.ordercode=item.ordercode
                             PurchaseList.time=item.time,
                             this.data.push(PurchaseList)
                        })
                        console.log( this.data)
                        this.loadingTable=false
                       // this.getSumPurchase(this.page,this.rows,startTime,endTime)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            modifyTime(data){
                this.valuedate[0] = data[0]
                this.valuedate[1] = data[1]
                this.selectTrade(this.valuedate[0],this.valuedate[1],this.page.page,this.page.rows,this.pagType)
            },
            onGongPageTotal(num){
                this.selectTrade(this.valuedate[0],this.valuedate[1],num,this.page.rows,this.pagType)
            },
            openFn(data){
              this.detailModal=true
              this.getData.forEach(item=>{
                  if(data.ids==item.id){
                       item.type=data.type
                       this.thispageData=item
                  }
              })
                this.$Api.getDebtList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                    code: data.ordercode
                }).then(res => {
                    if(res.code==200){
                       this.remark = res.data[0].remark
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

              
            }
        }
    };
</script>

<style lang="scss" scoped>
    .form-title{

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        color: #ff5e5e;
    }
    .tableFirst{
        color: #ff5e5e;
    }
</style>